import { call, delay, put, select, takeLatest } from 'redux-saga/effects';
import { actions } from './slice';
import { AxiosResponse } from 'axios';
import { DefaultEnum, PlanInterface } from '../types';
import { selectForm, SelectPageNo, SelectPageSize, SelectSearch, SelectSortColumn, SelectSortDir } from './selector';
import { doAddPlan, doGetPlanList, doGetPlanEdit, doUpdatePlan } from 'utils copy/request';
import { openSnackbar } from 'store/reducers/snackbar';
import CatchBlockFunction from 'hooks/CatchBlockFunction';

export function* doAddRequest(action: { payload: { callback: any } }) {
  yield delay(500);
  const form: PlanInterface = yield select(selectForm);

  if (form.hindiTitle.length === 0) {
    yield put(
      openSnackbar({
        open: true,
        message: 'please fill hindi title',
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: true
      })
    );
    return;
  }
  if (form.arabicTitle.length === 0) {
    yield put(
      openSnackbar({
        open: true,
        message: 'please fill arabic title',
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: true
      })
    );
    return;
  }
  if (form.englishTitle.length === 0) {
    yield put(
      openSnackbar({
        open: true,
        message: 'please fill english title',
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: true
      })
    );
    return;
  }
  if (form.isDefault == DefaultEnum.NO) {
    if (Number(form.iosAmount) <= 0) {
      yield put(
        openSnackbar({
          open: true,
          message: 'please fill valid IOS Amount',
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: true
        })
      );
      return;
    }
    if (Number(form.androidAmount) <= 0) {
      yield put(
        openSnackbar({
          open: true,
          message: 'please fill valid Android Amount',
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: true
        })
      );
      return;
    }
  } else {
    if (Number(form.iosAmount) > 0 || Number(form.iosAmount) < 0) {
      yield put(
        openSnackbar({
          open: true,
          message: 'please fill valid IOS Amount',
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: true
        })
      );
      return;
    }
    if (Number(form.androidAmount) > 0 || Number(form.androidAmount) < 0) {
      yield put(
        openSnackbar({
          open: true,
          message: 'please fill valid Android Amount',
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: true
        })
      );
      return;
    }
  }
  if (Number(form.order) < 0) {
    yield put(
      openSnackbar({
        open: true,
        message: 'please fill Order Of the Plan',
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: true
      })
    );
    return;
  }
  yield put(actions.setLoading(true));
  try {
    const response: AxiosResponse = yield call(doAddPlan, form);
    yield put(actions.setLoading(false));
    if (response && !response.data) {
      yield put(
        openSnackbar({
          open: true,
          message: response.data.message,
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: true
        })
      );
      return;
    }
    yield put(
      openSnackbar({
        open: true,
        message: response.data.message,
        variant: 'alert',
        alert: {
          color: 'success'
        },
        close: true
      })
    );
    yield call(action?.payload?.callback());
  } catch (error: any) {
    yield put(actions.setLoading(false));
    CatchBlockFunction(error);
  }
}
export function* doGetListRequest() {
  yield delay(500);

  try {
    const pageNo: number = yield select(SelectPageNo);
    const pageSize: number = yield select(SelectPageSize);
    const searchText: string = yield select(SelectSearch);
    yield put(actions.setLoading(true));
    const SortColumn: string = yield select(SelectSortColumn);
    const SortDir: string = yield select(SelectSortDir);
    const response: AxiosResponse = yield call(
      doGetPlanList,
      `?pageNo=${pageNo}&pageSize=${pageSize}${searchText.length > 0 ? '&search=' + searchText : ''}${
        SortColumn.length > 0 ? '&sortColumn=' + SortColumn : ''
      }${SortDir.length > 0 ? '&sortDir=' + SortDir : ''}`
    );
    yield put(actions.setLoading(false));
    if (response && !response.data) {
      yield put(
        openSnackbar({
          open: true,
          message: response.data.message,
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: true
        })
      );
      return;
    }
    yield put(actions.setTotalRow(response.data.data.meta ? response.data.data.meta.total : 0));
    yield put(actions.setList(response.data.data.results));
  } catch (error: any) {
    yield put(actions.setLoading(false));
    CatchBlockFunction(error);
  }
}
export function* doGetEditRequest(action: { payload: string }) {
  yield delay(500);
  try {
    const response: AxiosResponse = yield call(doGetPlanEdit, action.payload);
    if (response && !response.data) {
      yield put(
        openSnackbar({
          open: true,
          message: response.data.message,
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: true
        })
      );
      return;
    }

    yield put(actions.setDataForEdit(response.data.data));
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}
export function* doUpdateRequest(action: { payload: { callback: any } }) {
  yield delay(500);
  const form: PlanInterface = yield select(selectForm);

  if (form.hindiTitle.length === 0) {
    yield put(
      openSnackbar({
        open: true,
        message: 'please fill hindi title',
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: true
      })
    );
    return;
  }
  if (form.arabicTitle.length === 0) {
    yield put(
      openSnackbar({
        open: true,
        message: 'please fill arabic title',
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: true
      })
    );
    return;
  }
  if (form.englishTitle.length === 0) {
    yield put(
      openSnackbar({
        open: true,
        message: 'please fill english title',
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: true
      })
    );
    return;
  }
  if (form.isDefault == DefaultEnum.NO) {
    if (Number(form.iosAmount) <= 0) {
      yield put(
        openSnackbar({
          open: true,
          message: 'please fill valid IOS Amount',
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: true
        })
      );
      return;
    }
    if (Number(form.androidAmount) <= 0) {
      yield put(
        openSnackbar({
          open: true,
          message: 'please fill valid Android Amount',
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: true
        })
      );
      return;
    }
  } else {
    if (Number(form.iosAmount) > 0 || Number(form.iosAmount) < 0) {
      yield put(
        openSnackbar({
          open: true,
          message: 'please fill valid IOS Amount',
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: true
        })
      );
      return;
    }
    if (Number(form.androidAmount) > 0 || Number(form.androidAmount) < 0) {
      yield put(
        openSnackbar({
          open: true,
          message: 'please fill valid Android Amount',
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: true
        })
      );
      return;
    }
  }
  if (Number(form.order) < 0) {
    yield put(
      openSnackbar({
        open: true,
        message: 'please fill Order Of the Plan',
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: true
      })
    );
    return;
  }
  try {
    const response: AxiosResponse = yield call(doUpdatePlan, form);
    if (response && !response.data) {
      yield put(
        openSnackbar({
          open: true,
          message: response.data.message,
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: true
        })
      );
      return;
    }
    yield put(
      openSnackbar({
        open: true,
        message: response.data.message,
        variant: 'alert',
        alert: {
          color: 'success'
        },
        close: true
      })
    );
    yield call(action?.payload?.callback());
  } catch (error: any) {
    yield put(actions.setLoading(false));
    CatchBlockFunction(error);
  }
}

export function* PlanRepoSaga() {
  yield takeLatest(actions.doAdd, doAddRequest);
  yield takeLatest(actions.doGetList, doGetListRequest);
  yield takeLatest(actions.doGetEdit, doGetEditRequest);
  yield takeLatest(actions.doUpdate, doUpdateRequest);
}
